import api from '@/api'
import Vue from 'vue'

const state = {
  dispositivos: []
  // proveedor: []
}

const getters = {
  dispositivos: (state) => state.dispositivos,
  // proveedor: (state) => state.proveedor,
  dispositivosAsignados: (state) => state.dispositivos.filter(x => x.GEO_MEDIO_DISPOSITIVOS?.some(y => !y.FECHA_BAJA)),
  getDispositivoByID: (state) => (idDispositivo) => {
    return idDispositivo
      ? state.dispositivos.find(x => x.ID_GEO_DISPOSITIVO.equalsIgnoreCase(idDispositivo))
      : null
  },
  getDispositivoByISSI: (state) => (issi) => {
    return issi
      ? state.dispositivos.find(x => x.CODIGO_EXTERNO.equalsIgnoreCase(issi))
      : null
  },
  dispositivosConPosicion: (state) => {
    return state.dispositivos.filter(x => x.GEO_POS_ACTUAL)
  },
  dispositivoByIdRecurso: (state) => (idRecurso) => {
    return state.dispositivos.filter(x => x.GEO_MEDIO_DISPOSITIVOS.some(r => r.ID_RECURSO.equalsIgnoreCase(idRecurso) && !r.FECHA_BAJA))
  },
  dispositivoActivoByIdRecurso: (state, getters) => (idRecurso) => {
    const filtrados = getters.dispositivoByIdRecurso(idRecurso)
    return filtrados.reduce((ultimo, actual) => {
      const fechaUltimo = new Date(ultimo.GEO_POS_ACTUAL.FECHA)
      const fechaActual = new Date(actual.GEO_POS_ACTUAL.FECHA)
      return fechaActual > fechaUltimo ? actual : ultimo
    }, filtrados[0])
  }
}

const mutations = {
  SET_DISPOSITIVOS (state, dispositivos) {
    state.dispositivos = dispositivos
  },
  // SET_PROVEEDORES (state, proveedor) {
  //   state.proveedor = proveedor
  // },
  SOCKET_addDispositivo (state, dispositivo) {
    state.dispositivos.push(dispositivo)
    this.notify('Nuevo medio', `Se ha añadido el medio ${dispositivo.CODIGO_EXTERNO}`)
  },
  SOCKET_updateDispositivo (state, data) {
    const position = state.dispositivos.findIndex(
      x => x.ID_GEO_DISPOSITIVO.toLowerCase() === data.ID_GEO_DISPOSITIVO.toLowerCase()
    )

    if (position !== -1) {
      Vue.set(state.dispositivos, position, { ...data })
      this.notify?.('Dispositivo actualizado', `Se ha actualizado el dispositivo ${data.CODIGO_EXTERNO}`)
    }
  },
  SOCKET_deleteDispositivo (state, data) {
    const index = state.dispositivos.findIndex(x => x.ID_GEO_DISPOSITIVO.equalsIgnoreCase(data.ID_GEO_DISPOSITIVO))

    if (index !== -1) {
      state.dispositivos.splice(index, 1)
      this.notify('Dispositivo eliminado', `Se ha eliminado el dispositivo ${data.CODIGO_EXTERNO}`)
    }
  }
}

const actions = {
  async fetchDispositivos ({ commit, getters, dispatch }) {
    try {
      const response = await api.dispositivo.getDispositivos()
      commit('SET_DISPOSITIVOS', response.data)
    } catch (err) {
      console.error('Error al obtener los dispositivos:', err)
      throw err
    }
  },
  addDispositivo: async ({ commit, dispatch }, dispositivo) => {
    try {
      const res = await api.dispositivo.addDispositivo(dispositivo)
      // Si el backend responde con el nuevo ID:
      dispositivo.ID_GEO_DISPOSITIVO = res.data.ID_GEO_DISPOSITIVO

      commit('SOCKET_addDispositivo', dispositivo)
      dispatch('fetchDispositivos')
      return res
    } catch (err) {
      console.error('Error al añadir dispositivo:', err)
      throw err
    }
  },

  async updateDispositivo ({ commit, dispatch }, dispositivo) {
    try {
      const res = await api.dispositivo.updateDispositivo(dispositivo.ID_GEO_DISPOSITIVO, dispositivo)
      // res.data debería traer el dispositivo actualizado desde el backend
      commit('SOCKET_updateDispositivo', res.data)
      return res
    } catch (err) {
      console.error('Error al actualizar dispositivo:', err)
      throw err
    }
  },

  async deleteDispositivo ({ commit, dispatch }, id) {
    try {
      await api.dispositivo.deleteDispositivo(id)
      commit('SOCKET_deleteDispositivo', id)
    } catch (err) {
      console.error('Error al borrar dispositivo:', err)
      throw err
    }
  }
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
